import Markdown from 'markdown-to-jsx'
import { CustomComponents } from './CustomComponents'
import { MarkdownedProps } from './props'

const Markdowned = ({ text, options }: MarkdownedProps) => (
    <Markdown
        options={{
            overrides: {
                a: {
                    component: CustomComponents.a,
                },
                img: {
                    component: CustomComponents.img,
                },
            },
            ...options,
        }}
    >
        {text}
    </Markdown>
)

export default Markdowned
